<ng-container *ngIf="iconName && 0 < iconName.length" >
    <fa-icon [class]="cssClass" [icon]="myIcon" title="{{myTitle}}"></fa-icon>
</ng-container>
